import { Document } from '../../../jurisdiction/jurisdiction.domain';
import { AddressAndPersonalData } from './addressAndPersonalData';
import { GridApplicationDocumentTypes } from '../../../+grid-application-shared/entities/enums/grid-application-document-types.enum';

export class SubscriberAddress extends AddressAndPersonalData {
  constructor(application_id: number) {
    super(application_id);
    this.power_of_attorney = new Document(GridApplicationDocumentTypes.PowerOfAttorney);
  }

  businesspartner_id: number;
  owner_is_landlord: boolean;
  owner_is_pp_operator: boolean;
  owner_is_invoice_recepient: boolean;
  power_of_attorney: Document;
}
